import type { MaybeRefOrGetter } from 'vue';
import { computed, inject, toValue } from 'vue';

import type { Call } from '@stuut/api/models';

import type { CallProcessingStep } from '@/types/callProcessing';
import { getCallProcessingLabel, resolveCallProcessingStep } from '@/types/callProcessing';

export function useCallProcessingState(call: MaybeRefOrGetter<Call>) {
  const processingSteps = inject<Map<string, CallProcessingStep> | undefined>(
    'callProcessingSteps',
    undefined,
  );

  const processingStep = computed(() => resolveCallProcessingStep(toValue(call), processingSteps));

  const isProcessing = computed(() => !!processingStep.value);

  const processingLabel = computed(() =>
    processingStep.value ? getCallProcessingLabel(processingStep.value) : undefined,
  );

  return { processingStep, isProcessing, processingLabel };
}
